import { Loading } from "components/Loading/loading";
import { useEffect, useState } from "react";
import { getJobStatus } from "./api";
import { Headerbar } from "components/Headerbar/Headerbar";
interface JobStatusPropsType {
 
   
    jobId: any,

}

export const JobStatus = ({

    jobId,


}: JobStatusPropsType) => {
    const [response , setResponse]  = useState<any>([]);
    const [loading, setLoading] = useState(false);



async function getJobStatusAsync(jobId) {
    setLoading(false)
    try {
        const res =   await getJobStatus(jobId )
   
       setResponse(res.Data)
    } catch (error) {
        setResponse(null)
    }
    setLoading(true)

}





    useEffect( () => {
        if(jobId)
            getJobStatusAsync(jobId)
        
    }, [jobId]);



    

    return (
       

        <>
        <div  >




                  {
        loading ? (
            response ?
             <>
            <div style={{ justifyContent:"center"}}  className="d-flex align-items-center mt-2">
               <div className="col-8 col-lg-12 row mb-1">
                 <Headerbar
                   withPading={true}
                   headerContents={{
                      "JobStatus": response.JobStatus,
                      "JobStatusDate": response.JobStatusDate,
                      "JobStatusDescription": response.JobStatusDescription
                    }   }
                   hasBorder={true}
                 />
               </div>
             </div>

             </>
                : <></>      ) 

             : <Loading />
          }
        </div>        

        </>





    );
}